<template>
  <div class="answer-box" v-on:click="onTap">
    <div class="num">{{ id }}</div>
    <div class="answer" v-html="text"></div>
    <div class="icon"><img src="public/images/arrow1.svg" alt="" /></div>
  </div>
</template>

<script>
import router from '../../router';
export default {
  name: 'AnswerBox',
  props: {
    id: Number,
    text: String,
    correct: Boolean,
    useImage: Boolean,
  },
  methods: {
    onTap() {
      const correctness = this.correct ? 'c' : 'w';
      const quizId = this.id;
      if (this.correct) {
        this.playSound('quiz_correct');
      } else {
        this.playSound('quiz_wrong');
      }
      router.push('/answer/' + correctness + '/' + quizId);
    }
  }
}
</script>
